document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.getElementById('koji-live-hub');
  const screenArea = document.getElementById('koji-monitor-screen');
  const playerContainer = document.getElementById('koji-twitch-player');
  const activateBtn = document.getElementById('koji-activate-twitch');

  if (!playerContainer) return;

  const channel = playerContainer.getAttribute('data-channel');
  const parentHost = playerContainer.getAttribute('data-parent');
  
  // Controlla se la modalità Live è stata forzata dal backend di Shopify
  const isManualLive = wrapper.classList.contains('is-live-mode');

  // ==========================================
  // SENSORE RADAR: CONTROLLO LIVE ASINCRONO
  // ==========================================
  // Fa una chiamata di testo leggerissima per sapere se sei online senza caricare il player video
  function checkLiveStatus() {
    if (isManualLive) return; 

    fetch(`https://decapi.me/twitch/uptime/${channel}`)
      .then(res => res.text())
      .then(text => {
        if (text && !text.toLowerCase().includes('offline')) {
          wrapper.classList.add('is-live-mode');
        } else {
          wrapper.classList.remove('is-live-mode');
        }
      })
      .catch(e => console.log('Radar Koji: Interferenza segnale Twitch.'));
  }

  // Esegue il controllo all'avvio e poi ogni 60 secondi
  checkLiveStatus();
  setInterval(checkLiveStatus, 60000);


  if (!activateBtn) return;

  // ==========================================
  // LAZY LOADING: INIZIALIZZA IL PLAYER SOLO AL CLICK
  // ==========================================
  activateBtn.addEventListener('click', function(e) {
    e.preventDefault();
    
    activateBtn.innerHTML = '<span class="koji-play-icon">⏳</span><span>COLLEGAMENTO...</span>';
    activateBtn.style.opacity = '0.7';
    activateBtn.style.pointerEvents = 'none';

    if (typeof Twitch !== 'undefined') {
      initTwitchPlayer();
    } else {
      const script = document.createElement('script');
      script.src = 'https://player.twitch.tv/js/embed/v1.js';
      script.onload = () => initTwitchPlayer();
      document.head.appendChild(script);
    }
  });

  function initTwitchPlayer() {
    if (screenArea) screenArea.classList.add('is-loaded');

    const player = new Twitch.Player('koji-twitch-player', {
      channel: channel,
      parent: [parentHost],
      width: '100%',
      height: '100%',
      autoplay: true,
      muted: false
    });

    // Ascoltatori nativi del player per sicurezza, in caso il radar fallisca
    player.addEventListener(Twitch.Player.ONLINE, () => {
      if (wrapper) wrapper.classList.add('is-live-mode');
    });

    player.addEventListener(Twitch.Player.OFFLINE, () => {
      if (wrapper && !isManualLive) wrapper.classList.remove('is-live-mode');
    });
  }
});